/* eslint-disable camelcase */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable import/order */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
import React, {
  useState, useEffect, Fragment, useMemo,
} from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Drawer, Button, Tooltip, Modal, Spin,
} from 'antd';
import { toISTDate } from '@Apis/constants';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import Helpers from '@Apis/helpers';
import H3Text from '@Uilib/h3Text';
import dayjs from 'dayjs';
import H3Image from '@Uilib/h3Image';
import './style.scss';
import SO from '@Images/SO.jpg';
import closeIcon from '@Images/icons/icon-close-blue.png';
import FilterToAddSo from './FilterToAddSo';
import ViewSalesOrder from '../../../../Sales/SalesOrder/ViewSalesOrder';
import mrpV2Actions from '../../../../../actions/production/mrpV2Actions';
import H3Progress from '@Components/Common/H3Progress';
import documentUINamesConstant from '../../../../../apis/documentUINamesConstant';
import HideValue from '../../../../Common/RestrictedAccess/HideValue';

/**
 * @param status
 */

function SalesOrder({
  user, history, getMrpRunsLoading, getMrpV2Loading, createMrpV2Loading, mrpData, callback, MONEY, unlinkSoToMrpLoading, unlinkSoToMrp, priceMasking,
}) {
  const [showDrawerForFilterSo, setShowDrawerForFilterSo] = useState(false);
  const [viewSalesOrderDrawer, setViewSalesOrderDrawer] = useState(false);
  const [selectedSo, setSelectedSo] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  const getMrpColumns = () => {
    const mrpColumns = [
      {
        title: 'SO#',
        width: '150px',
        render: (record) => (
          <Link to={`/sales/sales-order/view/${record?.order_id}`} target="_blank">
            {record?.sales_order_number}
          </Link>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Customer',
        width: '220px',
        render: (text, record) => (
          <div className="mrp-v2-company__name">
            <Tooltip title={`${record?.internal_cust_code || ''} - ${record?.customer_info?.customer_name}`}>
              {Helpers.getPermission(Helpers.permissionEntities.CUSTOMER,
                Helpers.permissionTypes.READ, user)
                ? (record?.customer_info?.customer_name ? (
                  <span>
                    <Link to={`/sales/customer/view/${record?.customer_id || record?.customer_info?.customer_id}`} target="_blank">
                      {`#${record?.internal_cust_code || ''}`}
                    </Link>
                    <span>
                      {` - ${record?.customer_info?.customer_name}`}
                    </span>
                  </span>
                ) : '-') : (`${record?.internal_cust_code} - ${record?.customer_info?.customer_name}`)}
            </Tooltip>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Items',
        width: '55px',
        render: (item) => item?.line_count || 0,
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Order Total',
        render: (item, record) => ((isDataMaskingPolicyEnable && isHideSellingPrice) ? <HideValue showPopOver popOverMessage={"You don't have access to view order total"} /> : MONEY((record?.order_grand_total || '0'), record?.org_currency_info?.currency_code)),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      // {
      //   title: 'Order Date',
      //   width: '100px',
      //   render: (record) => (
      //     <div>
      //       {dayjs(record?.order_date).format('DD/MM/YYYY')}
      //     </div>
      //   ),
      //   responsive: ['sm', 'md', 'lg', 'xxl'],
      // },
      {
        title: 'Status',
        render: (item) => (
          <div className="mrp-so__status" style={{ color: Helpers.getStatusColor(item?.secondary_status)?.color }}>
            {Helpers.getStatusColor(item?.secondary_status).text?.toUpperCase()}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Delivery',
        render: (item) => (
          <div
            className="mrp-so__status"
            style={{ color: Helpers.getStatusColor(item?.shopify_order_id ? (item?.shopify_fulfillment_status?.toUpperCase() || 'PENDING') : (item?.fulfillment_status?.toUpperCase()))?.color }}
          >
            {item?.shopify_order_id ? (item?.shopify_fulfillment_status?.replaceAll('_', ' ').toUpperCase() || 'PENDING') : (item?.fulfillment_status?.replaceAll('_', ' ').toUpperCase())}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
      },
      {
        title: 'Delivery Date',
        width: '100px',
        render: (text, record) => toISTDate(record?.delivery_date).format('DD/MM/YYYY'),
        responsive: ['md', 'lg', 'xxl'],
      },
      {
        title: 'Availability',
        render: (text, record) => (
          <div>
            <H3Progress percent={record?.material_availability_absolute_percentage} barWidth={50} />
          </div>
        ),
        responsive: ['md', 'lg', 'xxl'],
      },
      {
        title: 'Reservation',
        render: (text, record) => (
          <div>
            <H3Progress percent={record?.reserved_percentage} barWidth={50} />
          </div>
        ),
        responsive: ['md', 'lg', 'xxl'],
      },
    ];
    mrpColumns.push({
      title: '',
      key: 'action',
      className: 'list__actions-column',
      fixed: 'right',
      width: '70px',
      render: (text, record) => (
        <div className="list__actions">
          <div
            style={{ width: '100%' }}
            className="list__actions-button"
            onClick={() => {
              setSelectedSo(record);
              setViewSalesOrderDrawer(true);
            }}
          >
            View
          </div>
        </div>
      ),
      responsive: ['md', 'lg', 'xxl'],
    });

    return mrpColumns;
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const processUnlink = ({ free_reserved_batch }) => {
    const payload = {
      mrp_id: mrpData?.mrp_id,
      order_ids: selectedRowKeys?.join(','),
      free_reserved_batch,
    };
    unlinkSoToMrp(payload, () => {
      setSelectedRowKeys([]);
      setSelectedRows([]);
      callback();
      setIsModalVisible(false); // Close the modal after processing
    });
  };

  const handleUnlinkSO = () => {
    // Handle unlink SO without freeing batches
    processUnlink({ free_reserved_batch: false });
    setIsModalVisible(false);
  };

  const handleUnlinkWithBatches = () => {
    // Handle unlink SO and free batches
    processUnlink({ free_reserved_batch: true });
    setIsModalVisible(false);
  };

  const documentUINames = useMemo(() => documentUINamesConstant(user), [user]);

  return (
    <Fragment>
      <Modal
        title={`Remove ${documentUINames.salesOrderUIName}s`}
        open={isModalVisible}
        onCancel={handleCancel}
        closable
        footer={false}
      >
        <p>{`Do you also want to free reserved batches for selected ${documentUINames.salesOrderUIName}s?`}</p>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Button
            key="unlink"
            onClick={handleUnlinkSO}
            disabled={unlinkSoToMrpLoading}
            style={{ marginBottom: '10px' }}
          >
            Remove Without Clearing Reservations
          </Button>
          <Button
            key="unlinkBatch"
            onClick={handleUnlinkWithBatches}
            type="primary"
            disabled={unlinkSoToMrpLoading}
            style={{ marginBottom: '10px' }}
          >
            Remove and Clear Reservations
          </Button>
          <Button
            key="back"
            onClick={handleCancel}
            disabled={unlinkSoToMrpLoading}
            style={{ marginBottom: '10px' }}
          >
            Cancel
          </Button>
        </div>
      </Modal>
      <Drawer
        width="1080px"
        title="Basic Drawer"
        placement="right"
        onClose={() => setViewSalesOrderDrawer(false)}
        open={viewSalesOrderDrawer}
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
            style={{
              position: 'static',
              width: '1035px',
            }}
          >
            <H3Text
              text={documentUINames.salesOrderUIName}
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setViewSalesOrderDrawer(false)}
            />
          </div>
          <div style={{ marginTop: '-20px' }}>
            <ViewSalesOrder
              key={selectedSo?.order_id}
              isQuickView
              selectedSoId={selectedSo?.order_id}
              selectedTenantId={selectedSo?.tenant_info?.tenant_id}
            />
          </div>
        </div>
      </Drawer>
      <Drawer
        width="1080px"
        placement="right"
        onClose={() => setShowDrawerForFilterSo(false)}
        open={showDrawerForFilterSo}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
            style={{
              position: 'static',
              width: '1035px',
            }}
          >
            <H3Text
              text={`Add ${documentUINames.salesOrderUIName}s to this materials plan`}
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setShowDrawerForFilterSo(false)}
            />
          </div>
          <FilterToAddSo
            mrpId={mrpData?.mrp_id}
            tenantId={mrpData?.tenant_id}
            callback={() => {
              setShowDrawerForFilterSo(false);
              callback();
            }}
            mrpData={mrpData}
          />
        </div>
      </Drawer>
      <div className="mo-so-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-24 ant-col-xs-24">
            <div className="manufacturing-orders__table">
              {((Number(mrpData?.linked_sales_orders?.length || 0) === 0)) ? (
                <Fragment>
                  {
                    (getMrpV2Loading || getMrpRunsLoading) ? <Spin className="mrp__no-so-loader" /> : (
                      <div className="mrp__no-so-wrapper">
                        <div className="mrp__no-so">
                          <img className="mrp__no-so__image" src={SO} alt={documentUINames.salesOrderUIName} />
                          <H3Text className={`mrp__no-so__text" text="You have not added any ${documentUINames.salesOrderUIName.toLowerCase()}s to this materials plan`} />
                          <div className="mrp__no-so__button-wrapper">
                            <Button
                              onClick={() => {
                                setShowDrawerForFilterSo(true);
                              }}
                              type="primary"
                              disabled={mrpData?.status === 'CLOSED'}
                            >
                              {`+ Add ${documentUINames.salesOrderUIName}s`}
                            </Button>
                          </div>
                        </div>
                      </div>
                    )
                  }
                </Fragment>
              ) : (
                <Fragment>
                  <div className="mrp__table-buttons">
                    <Button
                      danger
                      type="primary"
                      onClick={showModal}
                      customClass="mrp__add-button"
                      disabled={selectedRowKeys.length === 0}
                    >
                      {`Remove ${documentUINames.salesOrderUIName}s`}
                    </Button>
                    &nbsp;&nbsp;
                    <Button
                      type="primary"
                      onClick={() => {
                        setShowDrawerForFilterSo(true);
                      }}
                      customClass="mrp__add-button"
                      disabled={mrpData?.status === 'CLOSED'}
                    >
                      {`+ Add ${documentUINames.salesOrderUIName}s`}
                    </Button>
                  </div>
                  <Table
                    // title={() => (
                    //     <div className="mrp__table-header">
                    //       <div className="mrp__table-title">
                    //         <H3Text text={mrpData?.linked_sales_orders?.length || '0'} className="mrp__table-title-count" />
                    //         <span> Sales Order Selected</span>
                    //       </div>
                    //     </div>
                    // )}
                    bordered
                    loading={getMrpRunsLoading || createMrpV2Loading || unlinkSoToMrpLoading}
                    showHeader
                    size="small"
                    scroll={{ y: 'calc(100dvh - 290px)' }}
                    columns={getMrpColumns()}
                    dataSource={mrpData?.linked_sales_orders ? mrpData?.linked_sales_orders?.map((item, index) => ({
                      ...item,
                      key: item?.order_id,
                      index: index + 1,
                    })) : []}
                    pagination={false}
                    rowSelection={(window.screen.width > 425) ? {
                      onChange: (rowKeys, rows) => {
                        setSelectedRowKeys(rowKeys);
                        setSelectedRows(rows);
                      },
                      selectedRowKeys,
                    } : false}
                  />
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, MOReducers, MrpV2Reducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  createMrpV2Loading: MOReducers.createMrpV2Loading,
  mrpV2: MOReducers.mrpV2,
  getMrpV2Loading: MrpV2Reducers.getMrpV2Loading,
  unlinkSoToMrpLoading: MrpV2Reducers.unlinkSoToMrpLoading,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  unlinkSoToMrp: (payload, callback) => dispatch(mrpV2Actions.unlinkSoToMrp(payload, callback)),
});

SalesOrder.propTypes = {
  user: PropTypes.any,
  history: PropTypes.any,
  getMrpRunsLoading: PropTypes.bool,
  createMrpV2Loading: PropTypes.bool,

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SalesOrder));
